/*
 * The console's two languages, as portal-api spells them (`Me.locale`, `User.locale`). Slovenian
 * first: the people who use this console work in it.
 */
export enum Locale {
    Sl = 'sl',
    En = 'en',
}

export const LOCALES: Locale[] = [Locale.Sl, Locale.En]

export const DEFAULT_LOCALE = Locale.Sl

/** The BCP 47 tag Intl and the `lang` attribute are given for each language. */
export const INTL_LOCALE: Record<Locale, string> = {
    [Locale.Sl]: 'sl-SI',
    [Locale.En]: 'en-GB',
}
